/**
 * Scroll reveal — a restrained rise-and-fade in immersive, a plain fade in standard.
 * IntersectionObserver only; no scroll listener, no layout reads per frame.
 */

const targets = document.querySelectorAll('.reveal');

if (targets.length) {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach((el) => el.classList.add('is-in'));
  } else {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          // Stagger siblings a little so a group arrives as a sequence.
          const delay = Number(entry.target.dataset.revealDelay || 0);
          window.setTimeout(() => entry.target.classList.add('is-in'), delay);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
    );

    targets.forEach((el) => observer.observe(el));

    /* Failsafe. These elements start at opacity 0, so anything that stops the
       observer firing — a throttled background tab, an oversight in a future
       refactor — would leave content permanently invisible. Nothing stays
       hidden for longer than this, whatever happens. */
    window.setTimeout(() => {
      targets.forEach((el) => el.classList.add('is-in'));
    }, 2000);
  }
}
